

import React from 'react'
import Contact from '../../componentLayer/pages/contact/Contact'
export const contactRouter = [
  {
    // path : "contact",
    index: true,
    element: <Contact />,
  },
];
